@if (showAccessStatus) {
  @if ({ status: accessStatus$ | async, date: embargoDate$ | async }; as accessStatus) {
    <span [class]="'badge bg-secondary access-status-list-element-badge ' + accessStatusClass">{{ accessStatus.status | translate: {date: accessStatus.date} }}</span>
  }
}
